<div class="list">
	@for (category of contentStore.productCategories(); track $index) {
	<div [class]="getChipClass(category.variant)">
		<uis-optimized-image [source]="category.icon_name" height="18" width="18" alt="product icon">
		</uis-optimized-image>
		<p class="chip__text d-desktop">{{ category.display_name }}</p>
	</div>
	}
</div>
